const Shop = ( $ ) => {

	document.querySelectorAll( '.shop-list-item-link' ).forEach( ( link ) => {
		link.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			const item = link.closest( '.shop-list-item' );
			const openBlock = item.querySelector( '.shop-list-item-open' );

			if ( openBlock ) {
				openBlock.style.display = 'flex';
				openBlock.style.opacity = '0';
				openBlock.style.transition = 'opacity 0.4s ease';

				requestAnimationFrame( () => {
					openBlock.style.opacity = '1';
				} );
			}
		} );
	} );

	document.querySelectorAll( '.shop-list-item-close' ).forEach( ( closeBtn ) => {
		closeBtn.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			const item = closeBtn.closest( '.shop-list-item' );
			const openBlock = item.querySelector( '.shop-list-item-open' );

			if ( openBlock ) {
				openBlock.style.transition = 'opacity 0.4s ease';
				openBlock.style.opacity = '0';

				// After the animation is complete (after 400ms), hide
				setTimeout( () => {
					openBlock.style.display = 'none';
				}, 400 );
			}
		} );
	} );

	const items = document.querySelectorAll( '.shop-list-item' );
	const imgs = document.querySelectorAll( '.shop-conent-img' );

	// Показываем первый product-img по умолчанию
	if ( imgs.length ) {
		imgs[ 0 ].classList.add( 'active' );
	}

	items.forEach( ( item ) => {
		item.addEventListener( 'mouseenter', () => {
			const product = item.getAttribute( 'product' );

			imgs.forEach( ( img ) => {
				if ( img.getAttribute( 'product-img' ) === product ) {
					img.classList.add( 'active' );
				} else {
					img.classList.remove( 'active' );
				}
			} );
		} );
	} );

	$('.view-details').click(function () {
		const item = jQuery(this);
		if(item.parents('.product-item').find('.product-body').hasClass('open')){
			item.parents('.product-item').find('.product-body').slideUp().removeClass('open');
		}else{
			item.parents('.product-item').find('.product-body').slideDown().addClass('open');
		}
	});
	if($(window).width() < 768){
		$('.product-item').map(function () {
			const item = $(this);
			const itemDesc = item.find('.desc');
			const itemViewDetails = item.find('.view-details');
			const itemBody = item.find('.product-body');
			itemDesc.find('h3').after(itemBody);
			item.find('.add-to-cart').after(itemViewDetails);

		});
	}

	// Handle AJAX add to cart
	$(document).on('click', '.ajax_add_to_cart', function (e) {
		const $this = $(this);
		console.log('AJAX Add to Cart click', {
			product_id: $this.attr('data-product_id'),
			href: $this.attr('href'),
			classes: $this.attr('class')
		});

		if ($this.hasClass('disabled')) {
			e.preventDefault();
			return false;
		}

		if (!$this.attr('data-original-text')) {
			$this.attr('data-original-text', $this.html());
		}

		// Use .attr('data-product_id') instead of .data('product_id') to avoid automatic type conversion
		const product_id = $this.attr('data-product_id');

		// Check if it's a string containing multiple IDs
		if (product_id && product_id.indexOf(',') !== -1) {
			e.preventDefault();
			e.stopImmediatePropagation();

			if ($this.hasClass('loading')) return;

			$this.addClass('loading');
			$(document.body).trigger('adding_to_cart', [$this, { product_id: product_id }]);

			$.ajax({
				type: 'GET',
				url: $this.attr('href'), // Use the URL with add-to-cart-multiple
				beforeSend: function () {
					$this.addClass('loading');
				},
				complete: function () {
					$this.removeClass('loading');
				},
				success: function (response) {
					console.log('AJAX success response', response);
					if (typeof response === 'string' && response.includes('<!DOCTYPE html>')) {
						console.error('AJAX received HTML instead of JSON. Check server response for add-to-cart-multiple.');
						return;
					}
					if (response.success) {
						// Trigger WooCommerce fragments refresh
						const data = response.data || {};
						$(document.body).trigger('added_to_cart', [data.fragments || {}, data.cart_hash || '', $this]);
						$this.addClass('disabled').attr('aria-disabled', 'true');
					} else {
						if (response.data && response.data.message) {
							alert(response.data.message);
						}
						// Restore text on error
						if ($this.attr('data-original-text')) {
							$this.html($this.attr('data-original-text'));
						}
					}
				}
			});
		} else {
			// It's a single product.
			// WooCommerce's add-to-cart.js handles it because it has .add_to_cart_button class.
		}
	});

	// WooCommerce standard AJAX add to cart handling for single products
	$(document.body).on('added_to_cart', function(event, fragments, cart_hash, $button) {
		if ($button && $button.hasClass('ajax_add_to_cart')) {
			$button.addClass('disabled').attr('aria-disabled', 'true').removeClass('loading');

			// Prevent Bricks or WooCommerce from changing the button text or adding "View cart"
			// Use a slightly longer timeout or a direct update
			const restoreText = () => {
				// Remove the "View cart" link that WC adds automatically
				$button.parent().find('.added_to_cart').remove();

				// If Bricks or WC changed the text, restore it
				if ($button.attr('data-original-text')) {
					$button.html($button.attr('data-original-text'));
				}
			};

			restoreText();
			setTimeout(restoreText, 10);
			setTimeout(restoreText, 100);
			setTimeout(restoreText, 500);
		}
	});

	// Also catch the adding_to_cart event to store original text and show loading
	$(document.body).on('adding_to_cart', function(event, $button, data) {
		if ($button && $button.hasClass('ajax_add_to_cart')) {
			if (!$button.attr('data-original-text')) {
				$button.attr('data-original-text', $button.html());
			}
			// Optional: you could change the text to "Adding..." here if you want
			// but restoreText will bring it back anyway.
		}
	});

	// WooCommerce's add-to-cart.js script handles redirections if response has error: true.
	// We intercept that with global AJAX handler.
	$(document).ajaxComplete(function (event, xhr, settings) {
		if (settings.url && settings.url.indexOf('wc-ajax=add_to_cart') !== -1) {
			const response = xhr.responseJSON;
			if (response && response.error && response.product_url) {
				// Prevent redirection by clearing the product_url in response object or just alerting.
				// Since we can't easily clear the object used by WC script, we alert the error.

				// Most common error: 'Sold individually'
				// We can try to extract the error message from the page if WC doesn't provide it in JSON.
				// Actually, WC doesn't always provide the message in JSON.

				// However, if we're here, we can alert.
				// If response has error but no specific message, we might need to find it.
				// Let's try to find if there are any notices in the body.
				setTimeout(() => {
					const errorNotice = $('.woocommerce-error, .woocommerce-message').first().text().trim();
					if (errorNotice) {
						alert(errorNotice);
					}
				}, 100);
			}
		}
	});

	// const addButton = $('.single-add-cart a');
	// if (addButton.length) {
	// 	addButton.map(function( i, el ){
	// 		let href = $(el).attr('href');
	// 		$(el).addClass('brx_ajax_add_to_cart')
	// 		$(el).attr('href', href + '?add-to-cart='+ $(el).data('product_id'));
	// 	});
	// }

};

export default Shop;
